import { render, staticRenderFns } from "./ProductRr.vue?vue&type=template&id=49c4bfa3"
import script from "./ProductRr.vue?vue&type=script&lang=js"
export * from "./ProductRr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports